// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAYw53LEhZD_iMPbQc9h6BzyqbtvmRPcSQ",
  authDomain: "watchlist-website-1bac4.firebaseapp.com",
  projectId: "watchlist-website-1bac4",
  storageBucket: "watchlist-website-1bac4.firebasestorage.app",
  messagingSenderId: "223294903940",
  appId: "1:223294903940:web:bffd701f424c68252d14d1"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);


